import React from 'react';
import { Alert } from 'antd';

/**
 * Catches render-time crashes from a bad/edge-case template so the viewer
 * shows a readable error instead of a blank page. Also records the error on
 * `window.__lastRenderError` so automated checks can detect failures.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== 'undefined') {
      window.__lastRenderError = {
        message: error && error.message,
        stack: info && info.componentStack,
      };
    }
    // eslint-disable-next-line no-console
    console.error('[viewer] template render error:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 16 }} data-testid="render-error">
          <Alert
            type="error"
            showIcon
            message="This template could not be rendered"
            description={String(this.state.error.message || this.state.error)}
          />
        </div>
      );
    }
    return this.props.children;
  }
}
